import { Component, OnInit, Input, EventEmitter, Output, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { DataService } from '../../../services/forms/cheque-register/data.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { Employee } from '../../../models/employee.model';
import { GridService } from 'src/app/shared/services/grid.service';
@Component({
    selector: 'app-bank-branch-name-list',
    templateUrl: './../../../templates/forms/modals/bank-branch.component.html',
})
export class BankBranchNameListComponent implements OnInit {

    @ViewChild('modalContainer', { static: true, read: ViewContainerRef }) container;

    @Input()
    config: any;

    @Input()
    modalShow: boolean = true;

    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    dataObj: any;

    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "BankBranchNameListGrid"

    bankBranchNameList: any[] = [];
    searchFields: any[] = ['BANK_NAME', 'BRANCH_NAME'];
    public searchString;
    //constructor(public langService: LangService, private dataService: DataService) { }
    private modal: ModalService;

    constructor(public langService: LangService, private dataService: CommonService,
        public gridService: GridService) {
        this.colObj = [
            { headerName: langService.langData.bankName, field: 'BANK_NAME', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.branchName, field: 'BRANCH_NAME', sortable: true, resizable: true, hide: false },
        ];
    }

    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);

        this.dataService.getAllBanksName().subscribe(arg => {
            this.bankBranchNameList = arg.body
        });
    }
    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;
        this.submit.next();
    }
}
